import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import axiosInstance from "../../config/axiosInterceptor";

const AddBd = () => {
  const baseUrl = process.env.REACT_APP_BASEURL1;

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/bdpanel/createbd`,
        formData
      );

      console.log("API Response:", response.data);
      if(response.data.success==1)
      toast.success("BD panel successfully added");
    else toast.error(response.data.message)

      event.target.reset();
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error(error.message);
    }
  };

  return (
    <>
      <section className="content-header">
        <h1>Add Bd</h1>
        <ol className="breadcrumb">
          <li>
            <Link to="/admin">
              <i className="fa fa-dashboard"></i> Home
            </Link>
          </li>
          <li>
            <Link to="/admin/manageBd">Manage Bd</Link>
          </li>
          <li className="active">Add Bd</li>
        </ol>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-md-10">
            <form
              role="form"
              onSubmit={handleSubmit}
              encType="multipart/form-data"
            >
              <div className="box box-warning">
                <div className="box-header with-border">
                  <h3 className="box-title">Add</h3>
                </div>
                <div className="box-body">
                  <div className="form-group">
                    <label>Bd Name*</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Bd Name"
                    />
                  </div>
                  <div className="form-group">
                    <label>Bd Email*</label>
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      placeholder="Bd Email"
                    />
                  </div>
                  <div className="form-group">
                    <label>Bd Mobile*</label>
                    <input
                      type="text"
                      className="form-control"
                      name="number"
                      placeholder="Bd Mobile"
                    />
                  </div>
                  <div className="form-group">
                    <label>Bd Password*</label>
                    <input
                      type="text"
                      className="form-control"
                      name="password"
                      placeholder="Bd Password"
                    />
                  </div>
                  <div className="form-group">
                    <label>Bd Image*</label>
                    <input type="file" className="form-control" name="image" />
                  </div>

                  <div className="form-group">
                    <button type="reset" className="btn btn-danger">
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-success pull-right"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default AddBd;
